<template>
  <div class="sezione "  style="padding:0 20px;">

<div class="title_h1 yo-color-primary" style="margin-top:30px;">RICHIESTA DI ISCRIZIONE IN ATTESA DI APPROVAZIONE</div>
<br />
La Sua richiesta è stata inviata.
<br /><br />
Previa verifica dei documenti da Lei inseriti, i prossimi giorni riceverà conferma di autorizzazione da parte della Segreteria INNSIN per poter inserire le schede pazienti accedendo al sito https://www.innsin.it con le credenziali ricevute via mail.
<br /><br />
Cordiali saluti
<br />
La Segreteria INNSIN

   



  </div>
</template>

<script>
export default {
}
</script>


<style scoped>
  .home{
    background:#fff;
    min-height:600px;
    padding:20px;
  }
</style>
